<template>
  <div class="menu-func-bd">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" @click="onMenuAsFunc" :disabled="!selectedRow.menuId" v-if="functionView.menu_func_linked">
            <i class="icon icon-guanlian"></i>
            {{ $t('base_menu_func.bang_ding') }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onMenuDisAsFunc()" v-if="functionView.menu_func_unlink" :disabled="!tableSelect.length">
            <i class="icon icon-quxiaoguanlian"></i>
            {{ $t('base_menu_func.qu_xiao_bang_ding') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table type="checkbox" tableCode="fun_table" v-model="tableSelect" :data="funList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%"></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 关联功能 -->
    <menu-func-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getMenuFunList"></menu-func-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import menuFuncDialog from './menu_func_dialog';

export default {
  components: { menuFuncDialog },
  name: '',
  props: {
    appId: {
      type: [Number, String],
    },
    selectedRow: {
      type: Object,
      default() {
        return {};
      },
    },
    functionView: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tableSelect: [],
      dialogVisible: false,
      dialogModel: {},
      formSearch: {
        menuId: '',
        pageSize: 50,
        pageNum: 1,
      },
      funList: [],
      totalRows: 0,
    };
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView();

  },
  watch: {
    selectedRow: {
      handler: function () {
        this.formSearch = JSON.parse(this.resetFormSearch);
        this.getMenuFunList();
      },
      deep: true,
    },
  },
  methods: {
    // 获取菜单功能列表
    getMenuFunList: function () {
      if (!this.selectedRow.menuId) {
        this.funList = [];
        this.totalRows = 0;
        return;
      }
      this.isLoading = true;
      this.formSearch.menuId = this.selectedRow.menuId;
      this.$getJSON(apis.MenuAsFunc, this.formSearch).then((res) => {
        this.isLoading = false;
        this.funList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 菜单功能关联
    onMenuAsFunc: function () {
      this.dialogModel.title = this.$t('base_menu_func.bdmkgn');
      this.dialogModel.data = {};
      this.dialogModel.data.appId = this.appId;
      this.dialogModel.data.menuId = this.selectedRow.menuId;
      this.dialogVisible = true;
    },
    // 菜单取消功能关联
    onMenuDisAsFunc: function () {
      const tips = this.$t('base_menu_func.nqdyqxbdxzdmkgnm');
      this.$showConfirm(tips)
        .then(() => {
          const funcIds = this.tableSelect.map((t) => t.funcId);
          this.$postJSON(apis.MenuFuncDisAs, {
            funcIds: funcIds,
            menuId: this.selectedRow.menuId,
          }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getMenuFunList();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getMenuFunList();
    },
  },
};
</script>

<style lang="scss"></style>
